import { ErrorHandler, Injectable } from '@angular/core';

import { MessageService } from './message-service';

import { SharedSettings } from '../models/shared-settings';

import { LoggingService } from './logging.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private messageService: MessageService,
        private settings: SharedSettings,
        private logger: LoggingService) {}

    handleError(error: any): void {
        this.logger.exception(error);

        this.messageService.add({
            severity: 'error',
            summary: 'An Error has Occurred',
            detail: 'An unknown error has occurred. If this persists, please contact PLA support.'
                + (this.settings.isProduction ? '' : '\n' + error.toString()),
            sticky: true
        });
    }
}
